import * as yup from 'yup';

export const login_schema = {
  username: '',
  password: '',
};

export const login_validation_schema = yup.object().shape({
  username: yup.string().required('username_required'),
  password: yup.string().required('password_required'),
});
